export const COMPANY_LINKS = [
  ["About", "/about"],
  ["Careers", "/careers"],
  ["Legal Entity & Certificates", "/legal-entity"],
  ["Home", "/"],
];
